import { HTMLProps, ReactNode, FC, memo } from 'react'
import { Panel } from './Panel'

interface PropsType extends HTMLProps<HTMLDivElement> {
  children: ReactNode
}

const Collapse: FC<PropsType> = ({ children }) => <div>{children}</div>

export default Object.assign(memo(Collapse), {
  Panel
})
